import axios from './api';

export const DEFAULT_SETTINGS = {
    brandName: "Guraba's Choice",
    primaryColor: '#007bff',
    secondaryColor: '#6c757d',
    currency: 'BDT',
    paymentMethods: [
        { name: 'bkash', enabled: true },
        { name: 'nagad', enabled: false },
        { name: 'ssl_commerce', enabled: false }
    ],
    address: '',
    whatsapp: '',
    contactWidget: {
        enabled: false,
        call: { enabled: true, phone: '' },
        whatsapp: { enabled: true, phone: '' },
        telegram: { enabled: true, url: '' },
        messenger: { enabled: true, url: '' }
    },
    brandLogo: '',
    siteFavicon: '',
    appleTouchIcon: '',
    showBrandLogoInNavbar: false,
    showBrandNameInNavbar: true,
    seoTitle: '',
    seoDescription: '',
    seoKeywords: '',
    seoAuthor: '',
    seoImage: '',
    seoCanonicalUrl: '',
    seoRobots: 'index, follow',
    productListPageSize: 12,
    deliveryChargeSettings: {
        enabled: false,
        insideDhakaAmount: 0,
        outsideDhakaAmount: 0,
        advancedEnabled: false
    },
    couponSettings: {
        enabled: true
    },
    productCardActions: {
        showAddToCart: true,
        showBuyNow: true,
        showWishlist: true
    },
    productDisplayColors: {
        priceText: '#000000',
        addToCart: '#000000',
        buyNow: '#000000'
    }
};

let cachedSettings = null;
let pendingSettingsRequest = null;

export const getCachedSettings = () => cachedSettings;

export const setCachedSettings = (settings) => {
    cachedSettings = settings;
};

export const loadSettings = async ({ force = false } = {}) => {
    if (!force && cachedSettings) {
        return cachedSettings;
    }

    if (!force && pendingSettingsRequest) {
        return pendingSettingsRequest;
    }

    pendingSettingsRequest = axios.get('/api/settings')
        .then((res) => {
            cachedSettings = res.data;
            return cachedSettings;
        })
        .finally(() => {
            pendingSettingsRequest = null;
        });

    return pendingSettingsRequest;
};
